<template>
  <div>
    <small
      class="text-muted"
      v-if="group_prescription_care.prescription_care.care_category"
    >
      ({{ group_prescription_care.prescription_care.care_category }})
    </small>
    <h6 class="mb-0">
      {{ group_prescription_care.prescription_care.care_name }}
    </h6>
    <h6
      class="legends mb-1 worksansr"
      v-if="group_prescription_care.prescription_care.instruction"
    >
      INSTRUÇÃO:
      {{ group_prescription_care.prescription_care.instruction }}
    </h6>
    <div
      v-if="group_prescription_care.prescription_care.frequency == 'EVENTUAL'"
    >
      <h6>
        Pode checar a cada
        {{
          handleEvery(
            group_prescription_care.prescription_care.care_amount_of_times_value
          )
        }}. ({{
          group_prescription_care.prescription_care.care_amount_of_times_value
        }}x).
      </h6>
    </div>
  </div>
</template>

<script>
export default {
  name: "Care",
  props: {
    group_prescription_care: Object,
  },
  methods: {
    handleEvery(value) {
      return `${Math.round(24 / value)} horas`;
    },
  },
};
</script>
